import { Avatar, Box, Card, Rating, Typography } from "@mui/material"
import { useApiService } from "../../hooks/Api/useApiService"
import { useNavigate } from "react-router-dom"
import styles from "./UserSection.module.css"
import Icn from "../../UI/SharieIcn/SharieIcn"
import T from "../../hooks/Language/T"
import React, { useRef } from "react"
import { Message as MessageIcon } from "@mui/icons-material"
import ChatModal from "../../Modals/ChatModal/ChatModal"

const UserSection = (props) => {
  const navigate = useNavigate()
  const { postData } = useApiService()
  const chatRef = useRef()

  const handleAvatarClick = () => {
    try {
      postData("sharie/addnotification", {
        skill_name: null,
        from: localStorage.getItem("user"),
        type: "view profile",
      }).then((data) => {})
    } catch (error) {
      console.error("Error sending notification:", error)
    }

    navigate("/profile", {
      state: {
        user_name: props.user?.user_name,
        editable: localStorage.getItem("user") === props.user?.user_name,
      },
    })
  }
  const openModal = (modalRef) => modalRef.current?.childFunction()

  return (
    <T>
      <ChatModal
        ref={chatRef}
        chat_user={localStorage.getItem("user")}
        to={props.user?.user_name}
      />
      <div className={styles.topuser_container}>
        <Card className={styles.topuser_card} sx={{ boxShadow: props.top_skills ? "none" : "" }}>
          <Box display='flex' justifyContent='space-between' alignItems='center'>
            <Icn
              tooltip={"View Profile"}
              onClick={handleAvatarClick}
              avatar={<Avatar src={props.user?.image} style={{ border: "3px solid  #1976d2" }} />}
            />
            <Typography variant='h6' component='div' gutterBottom>
              {props.user?.user_name}
            </Typography>
            {localStorage.getItem("user") !== props.user?.user_name && (
              <Icn
                tooltip='Chat'
                color='lightGreen'
                onClick={() => openModal(chatRef)}
                label='message'
                icon={<MessageIcon />}
              />
            )}
          </Box>

          {!props.user?.remove_rating && (
            <Rating
              name='skill-rating'
              value={Number(props.user?.rating) || 0}
              precision={1}
              readOnly
              className={styles.rating}
            />
          )}
        </Card>
      </div>
    </T>
  )
}

export default React.memo(UserSection)
